function getEnvironment() {
    const isDev = process?.env?.NODE_ENV === "development";
    const baseUrl = isDev ? "http://localhost:5001" : "";
    return baseUrl;
  }
  const basePath = getEnvironment();
  export { basePath };


  const hexConverter = (cardId) => {
      switch (cardId){
        case 0:
            return "#FF555E";
        case 1:
            return "#FF8650";
        case 2:
            return "#FFE981";
        case 3:
            return "#8BF18B";
        case 4:
            return "#83B2FF";
        case 5:
            return "#9B6EF3";
        default:
            return "#6EC05D";    
    }
  };
  export {hexConverter};